import jmespath from 'jmespath'
import { Feature } from 'geojson'

export const getPropertyValues = (features: Feature[], key: string) => {
  const values = jmespath.search(features, `[*].properties."${key}"`)
  return [...new Set(values)]
}
